import { useNavigate } from 'react-router-dom'
import { User } from '../../Api/Lirari/Types/user'

const UsersList = ({ users }: { users: User[] }) => {
  const navigate = useNavigate()

  const usersList = users.map((user) => ({
    ...user,
    locationName: user.locationFormattedString?.split(','),
  }))

  const goToUser = (id: string) => {
    navigate(`/u/${id}`)
  }

  return (
    <div className="lg:grid lg:grid-cols-3 lg:py-[30px] pb-[30px] lg:px-0 px-2 lg:mx-5 lg:w-3/4 w-full gap-5">
      {usersList.length > 0
        ? usersList.map((user) => (
            <div
              key={user.id}
              className="flex flex-col items-center h-fit backdrop-blur-sm bg-gradient-to-b from-[#494949]/80 to-[#242424]/80 text-white rounded-2xl p-4 shadow-lg relative overflow-hidden cursor-pointer"
              onClick={() => goToUser(user.id)}
            >
              <div className="flex flex-col items-center text-center">
                <div className="flex justify-between relative w-32 h-32 rounded-full overflow-hidden border-4 border-white">
                  <img
                    src={
                      user.profileImageUrl ||
                      'https://storage.googleapis.com/demo-profile/images/the-musician-unblurred.png'
                    }
                    alt={`${user.firstName} ${user.lastName}`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col space-y-1">
                  <p className="text-xl font-bold whitespace-break-spaces">{user.firstName}</p>
                  <p className="text-xl font-bold whitespace-break-spaces">{user.lastName}</p>
                  <p className="text-gray-400r"> {user.locationName && `${user.locationName[0]},`}</p>
                  <p className="text-gray-400r">
                    {user.locationName[1]?.trim() == 'Israel' || (!user.locationName[1] && user.locationName[0])
                      ? 'Palestine'
                      : user.locationName[1]?.trim()}
                  </p>
                </div>
                <p className="text-sm mt-2">Buzuqist | Pianist | Singer</p>
              </div>
              {user.userGenres.length > 0 ? (
                <div className="mt-4">
                  <h3 className="text-md text-center font-semibold">Other Genres</h3>
                  <div className="flex gap-2 mt-2">
                    <span className="bg-black text-white text-sm px-3 py-1 rounded-full">
                      {user.userGenres[0].genre.name}
                    </span>
                    {user.userGenres.length > 1 ? (
                      <span className="bg-black text-white text-sm px-3 py-1 rounded-full">
                        {user.userGenres[1].genre.name}
                      </span>
                    ) : null}
                  </div>
                </div>
              ) : null}
              {user.userOfferings.length > 0 ? (
                <div className="mt-4">
                  <h3 className="text-md text-center font-semibold">Other Offerings</h3>
                  <div className="flex gap-2 mt-2">
                    <span className="bg-black text-white text-sm px-3 py-1 rounded-full">
                      {user.userOfferings[0].offering.name}
                    </span>
                    {user.userOfferings.length > 1 ? (
                      <span className="bg-black text-white text-sm px-3 py-1 rounded-full">
                        {user.userOfferings[1].offering.name}
                      </span>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          ))
        : null}
    </div>
  )
}
export default UsersList
